import { render, staticRenderFns } from "./presens-av-haben.vue?vue&type=template&id=2e1b625d&scoped=true"
import script from "./presens-av-haben.vue?vue&type=script&lang=js"
export * from "./presens-av-haben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b625d",
  null
  
)

export default component.exports